import { useTranslation } from "next-i18next";
import styles from "./product-delivery.module.scss";

function PickUpOnlyWarning(props: any) {
  const { classNames } = props;
  const { t } = useTranslation();
  return (
    <div className={classNames}>
      <div className={styles.warning_heading}>
        <i className={`fa fa-exclamation-triangle m-r-5 ${styles.alert_icon} `} />
        <span>
          {t("only_instore_pickup")}
        </span>
      </div>
      <div className={styles.sorry_text}>
        <span>{t("no_store_100Km")}</span>
      </div>
    </div>

  );
}

export default PickUpOnlyWarning;
